import gql from 'graphql-tag';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const GET_APP_NAVIGATION_QUERY = gql `
  query navigation($navMetadata: NavMetadata!) {
    navigation(navMetadata: $navMetadata) {
      id
      title
      page
      logo {
        src
        url
        title
      }
      search {
        url
        title
      }
      appSwitcher {
        title
        defaultOpen
        items {
          icon
          title
          status
          url {
            href
          }
        }
      }
      globalNav {
        current
        title
        titleKey
        url {
          href
        }
        items {
          current
          title
          titleKey
          url {
            href
          }
        }
      }
      localNav {
        title
        titleKey
        current
        url {
          href
        }
        items {
          title
          titleKey
          current
          url {
            href
          }
          items {
            current
            title
            titleKey
            url {
              href
            }
          }
        }
      }
    }
  }
`;
//# sourceMappingURL=queries.js.map